<template>
  <OfflineLayout>
    <TabView lazy>
      <TabPanel :header="$t('nav.login')">
        <LoginForm />
      </TabPanel>
      <TabPanel :header="$t('nav.register')">
        <RegisterForm />
      </TabPanel>
    </TabView>
  </OfflineLayout>
</template>

<script>
import OfflineLayout from '@/layouts/OfflineLayout'
import LoginForm from "@/components/LoginForm";
import RegisterForm from "@/components/RegisterForm";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";

export default {
  name: 'LoginView',
  components: {RegisterForm, LoginForm, OfflineLayout, TabView, TabPanel}
}
</script>

<style scoped>

</style>

